import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { SelectMockComponent } from "./select-mock.component.js";
import { SelectMockRoot, Icon, Tabs, TabLink, TabContent } from "./select-mock.styles.js";
import { PostMessageComponent } from "./post-message.component.js";
function SelectMockContainer({
  render,
  mocks,
  children
}) {
  const [isBoxShow, setIsBoxShow] = useState(false);
  const [index, setIndex] = useState(0);
  const [isSafeToRender, setSafeToRender] = useState(false);
  useEffect(() => {
    try {
      if (localStorage && sessionStorage) setSafeToRender(true);
    } catch {
      setSafeToRender(false);
    }
  }, []);
  function toggleBox() {
    setIsBoxShow((prevValue) => !prevValue);
  }
  function handleTabClick(index2) {
    return () => {
      setIndex(index2);
    };
  }
  return render && isSafeToRender ? /* @__PURE__ */ jsxs(SelectMockRoot, { style: { bottom: isBoxShow ? "0px" : "-415px" }, children: [
    /* @__PURE__ */ jsx(Icon, { id: "mock-icon-open", onClick: toggleBox, children: ">" }),
    /* @__PURE__ */ jsxs(Tabs, { children: [
      /* @__PURE__ */ jsx(TabLink, { active: index === 0, onClick: handleTabClick(0), children: "Mock Request" }),
      /* @__PURE__ */ jsx(TabLink, { active: index === 1, onClick: handleTabClick(1), children: "Post Messages" }),
      /* @__PURE__ */ jsx(TabLink, { active: index === 1, onClick: handleTabClick(2), children: "Actions" })
    ] }),
    /* @__PURE__ */ jsx(TabContent, { selected: index === 0, children: index === 0 && /* @__PURE__ */ jsx(SelectMockComponent, { mockDebugList: mocks }) }),
    /* @__PURE__ */ jsx(TabContent, { selected: index === 1, children: index === 1 && /* @__PURE__ */ jsx(PostMessageComponent, {}) }),
    /* @__PURE__ */ jsx(TabContent, { selected: index === 2, children })
  ] }) : /* @__PURE__ */ jsx(Fragment, {});
}
export {
  SelectMockContainer
};
//# sourceMappingURL=select-mock.container.js.map
